export interface IImageSize {
  url: string;
  height: number;
}
